<template>
	<div id="main-content" role="main" class="webview">
		<slot></slot>
	</div>
</template>

<script setup lang="ts"></script>
